import {
  WSGrid,
  WSList,
  WSPage,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { useHistory } from "react-router-dom";
import { useFocusedFeatures } from "../../../FocusedFeatures";
import { useQueryTaxEstimate } from "@hooks/useQueryTaxEstimate";
import { DataView } from "../../../shared/components/DataView";
import { AlertEnableTaxWithholdings } from "../../TaxWithholdings/components/AlertEnableTaxWithholdings";
import { AlertEstimatedTaxWithholdings } from "../../TaxWithholdings/components/AlertEstimatedTaxWithholdings";
import { CardTaxWithholdingStatus } from "../../TaxWithholdings/components/CardTaxWithholdingStatus";
import { PATH_TAX_WITHHOLDINGS_EDIT_TAX_RATE } from "../../TaxWithholdings/paths";
import {
  formatFilingStatus,
  formatStateOfResidence
} from "../../TaxWithholdings/utils";
import { BannerBankingVerification } from "../../Wallet/components/BannerBankingVerification";
import { PATH_SETTINGS_TAX_PROFILE } from "../paths";

export const RouteTaxProfile = () => {
  const history = useHistory();
  const focusedFeatures = useFocusedFeatures();
  // v1 read these three off the member profile's `taxInfo`. v3 stores filing
  // status and state on the tax-withholding settings; the panel reads them off
  // the estimate, which echoes what it computed with, and shows the account's
  // actual platform income in place of the member's own expected-income bracket.
  const queryTaxEstimate = useQueryTaxEstimate(new Date().getFullYear());
  const taxEstimate = queryTaxEstimate.data;

  return (
    <WSPage>
      <WSPageToolbar title="Tax profile" />

      <WSGrid gutter="2XL">
        <WSGrid.Item span={{ s: "12", m: "8" }}>
          <WSList gap="2XL">
            <BannerBankingVerification />

            {focusedFeatures.showSideNavFinancialBenefits && (
              <AlertEnableTaxWithholdings />
            )}

            {focusedFeatures.showSideNavFinancialBenefits && (
              <AlertEstimatedTaxWithholdings />
            )}

            <DataView
              title="Filing basic"
              onEdit={() => {
                history.push(PATH_TAX_WITHHOLDINGS_EDIT_TAX_RATE, {
                  backPath: PATH_SETTINGS_TAX_PROFILE,
                  nextPath: PATH_SETTINGS_TAX_PROFILE
                });
              }}
              data={[
                {
                  label: "Tax filing status",
                  value: formatFilingStatus(taxEstimate?.filingStatus)
                },
                {
                  label: "Estimated annual income",
                  value:
                    taxEstimate?.totalIncome === undefined
                      ? undefined
                      : formatMoney(taxEstimate.totalIncome, "USD")
                },
                {
                  label: "Tax filing state",
                  value: formatStateOfResidence(taxEstimate?.state)
                }
              ]}
            />
          </WSList>
        </WSGrid.Item>

        {focusedFeatures.showSideNavFinancialBenefits && (
          <WSGrid.Item span={{ s: "12", m: "4" }}>
            <WSList gap="2XL">
              <CardTaxWithholdingStatus isSettings />
            </WSList>
          </WSGrid.Item>
        )}
      </WSGrid>
    </WSPage>
  );
};
